import StreamForm from "../../../components/data_products/streams/StreamForm";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {useDifactoBucket} from "../../../components/utils";
import { useCreateStreamMutation } from "../../../api/streamApiSlice";

function NewStream(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const bucket = useDifactoBucket();

  const goToStream = (data) => history.push(`/streams/${data.key}`)

  const [newStream] = useCreateStreamMutation()

  const submitProps = {
    handleSubmit: (data) => {
      newStream(data).unwrap()
        .then(goToStream)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.streams")}
        sub={t("new")}
        group={false}
        backPath="/streams">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <StreamForm {...submitProps} setSubmitButtonProps={setSubmitButtonProps} bucket={bucket}/>
    </>
  )
}

export default NewStream
